// @flow

export function fillTemplateString(templateText: string, args: string[]) {
  let str = templateText;
  let placeholder = '';
  args.map((arg, i) => {
    placeholder = new RegExp(`\\{${i}\\}`);
    str = str.replace(placeholder, arg);
    return null;
  });
  return str;
}

export default {
  fillTemplateString
};



// WEBPACK FOOTER //
// ./src/utils/json-helpers.js